export const MEDIA_LABEL_ICON_DATA_HOOK = 'media-label-icon';
export const MEDIA_LABEL_TEXT_DATA_HOOK = 'media-label-text';
